/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Select } from 'sarsaparilla';

const VEHICLE_INFORMATION_PROP_PATH = 'vehicle_information';

const dropdownOptions = [
    {
        label: 'Green sticker ATV',
        value: 'Green sticker ATV',
    },
    {
        label: 'Green sticker UTV',
        value: 'Green sticker UTV',
    },
];

function AtvVehicleInfoFrom({
    reservation,
    changeVehicleSelection,
    addToInputRefs,
    vIndex,
}) {
    const selectedVehicleType = get(
        reservation,
        `${VEHICLE_INFORMATION_PROP_PATH}.make`,
        ''
    );
    return (
        <div className="permit-vehicle-wrap">
            <div className="rec-nested-wrap">
                <div className="rec-grid-12-12">
                    <h1 className="form-section-header">Vehicle</h1>
                    <p>
                        Only Green stickered UTV and ATVs are allowed in Clear Creek
                        Management Area. Green sticker means that it meets the
                        requirements for off highway vehicles in the state of California.
                    </p>
                </div>
                <div className="rec-grid-12-12">
                    <div className="rec-nested-wrap">
                        <div className="rec-grid-4-12">
                            <Select
                                label="Vehicle Type"
                                id="dropdown-vehicle-type"
                                placeholder="Select a vehicle type"
                                options={dropdownOptions}
                                onChange={changeVehicleSelection}
                                value={selectedVehicleType}
                                isRequired
                                ref={addToInputRefs(vIndex + 11)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

AtvVehicleInfoFrom.propTypes = {
    reservation: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    onFormValidate: PropTypes.func,
    changeVehicleSelection: PropTypes.func.isRequired,
    displayValidationError: PropTypes.bool,
};

export default AtvVehicleInfoFrom;
